import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { ContractDetailSearch, ContractResult } from "@/views/contract/manage/ContractManageTypes";
import { summaryModel } from "../../customer/summaryModel";

export const contractDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs, setLoadingInfo } = useGlobalModel();
    const { detailPartner } = summaryModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<ContractDetailSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ContractResult[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<ContractResult[]>([]);

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onReset = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([]);
    }

    const updateSearchParam = (updateParam: ContractDetailSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ContractDetailSearch = searchParam) => {
        setLoading(true);
        setDataSource([]);
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            partnerCode: detailPartner,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }

        let { retData } = await contractManageService.contractSummaryPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }

    //导出
    const contractExport = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '导出中,请稍等...' });
        let contractCodes = null;
        if (selectedData.length > 0) {
            contractCodes = selectedData.map(e => e.code)
        }
        const searchParams = {
            ...defaultMdCmParam,
            ...searchParam,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            partnerCode: detailPartner,
            contractCodes: contractCodes,
        }
        let result = await contractManageService.contractExport(searchParams);
        convertRes2Blob(result);
        setLoadingInfo({ loadingVisible: false, txt: '' });
    }

    return {
        /***field***/
        loading,
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedData,
        pgCfg,
        beDs,
        /***method***/
        setDataSource,
        updateSearchParam,
        loadData,
        setSelectedRowKeys,
        setSelectedData,
        onSearch,
        onReset,
        contractExport,
    }
});